import { useConfig } from 'builder/hooks/useConfig'

const Config = ({ children }) => {
  const config = useConfig()
  return typeof children === 'function' ? children(config) : children
}

export default Config
